import React from "react";
import MediaQuery from "react-responsive";

export const SPView: React.FC<React.PropsWithChildren<unknown>> = (props) => {
  return <MediaQuery query="(max-width: 767px)">{props.children}</MediaQuery>;
};

export const PCView: React.FC<React.PropsWithChildren<unknown>> = (props) => {
  return <MediaQuery query="(min-width: 768px)">{props.children}</MediaQuery>;
};
